import {
  ApiFilterOperation,
  FormPanel,
  TableField,
  TableFieldCells,
  DetailContext,
} from '@eas/common-web';
import { noop } from 'lodash';
import React, { useContext, useEffect } from 'react';
import { FormPanelCountByName } from '../../components/form/form-panel-summary/form-panel-count';
import { redirectToDetailCellFactory } from '../../composite/subject-cells/redirect-to-detail-cell';
import { EvidenceUrl, Permission } from '../../enums';
import { useMinimalDistances } from '../minimal-distances/minimal-distances-api';
import { InactiveColoredTableFieldRow } from '../../components/form/inactive-colored/inactive-colored-table-field-row';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Remove';
import { OvzFacility } from '../../models';

const columns = [
  {
    name: 'Odkaz',
    datakey: 'id',
    width: 60,
    CellComponent: redirectToDetailCellFactory(
      EvidenceUrl.MINIMAL_DISTANCES_SOURCE
    ),
  },
  {
    datakey: 'sourceId',
    name: 'Číslo zdroje',
    width: 200,
  },
  {
    datakey: 'name',
    name: 'Název zdroje',
    width: 200,
  },
  {
    datakey: 'sourceCategory.code',
    name: 'Kategorie',
    width: 200,
  },
  {
    datakey: 'exemptFromMinDistances',
    name: 'Má výjimku MV',
    width: 200,
    CellComponent: TableFieldCells.BooleanCell,
  },
  {
    datakey: 'active',
    name: 'Zneplatněno',
    width: 200,
    CellComponent: function Cell({ value }: { value: boolean }) {
      return <>{value ? <ClearIcon /> : <CheckIcon />}</>;
    },
  },
];

const csvColumns = [
  ...columns.filter(
    (c) => !['id', 'exemptFromMinDistances', 'active'].includes(c.datakey)
  ),
  {
    datakey: 'exemptFromMinDistances',
    name: 'Má výjimku MV',
    width: 200,
    CellComponent: function Cell({ value }: { value: boolean }) {
      return <>{value ? 'ANO' : 'NE'}</>;
    },
  },
  {
    datakey: 'active',
    name: 'Zneplatněno',
    width: 200,
    CellComponent: function Cell({ value }: { value: boolean }) {
      return <>{value ? 'NE' : 'ANO'}</>;
    },
  },
];

export function OvzFacilitiesMinimalDistancesTable({
  facilityId,
  operator,
}: {
  facilityId?: string;
  operator?: OvzFacility['operator'];
}) {
  const { addRefreshListener, removeRefreshListener } = useContext(
    DetailContext
  );

  const [result, , refetch] = useMinimalDistances({
    size: -1,
    filters: [
      {
        operation: ApiFilterOperation.EQ,
        field: 'ovzFacility.id',
        value: facilityId,
      },
    ],
  });

  useEffect(() => {
    addRefreshListener(refetch);
    return () => {
      removeRefreshListener(refetch);
    };
  }, [refetch, addRefreshListener, removeRefreshListener]);

  return (
    <>
      <FormPanel
        label="Zdroje - Minimální vzdálenosti"
        expandable
        defaultExpanded={false}
        summary={
          <FormPanelCountByName
            name="users"
            count={result?.count}
            items={result?.items ?? []}
            columns={csvColumns}
            permission={Permission.MinimalDistances.MINIMAL_DISTANCES_LIST_OWN}
            permissionState={{
              searchInSubjectPerms: true,
              subjectId: operator?.id,
            }}
          />
        }
      >
        <TableField
          disabled
          showToolbar={false}
          value={result?.items ?? []}
          onChange={noop}
          showDetailBtnCond={() => false}
          showRadioCond={() => false}
          onRowClick={noop}
          columns={columns}
          RowComponent={InactiveColoredTableFieldRow}
        />
      </FormPanel>
    </>
  );
}
